import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  const location = useLocation();
  const currentSlug = location.pathname.split('/').pop() || categories[0].slug;

  return (
    <div className="flex items-center gap-1 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      {categories.map((cat) => {
        const isActive = currentSlug === cat.slug;
        return (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
              isActive
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
            }`}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className={`${cat.icon} text-xs`}></i>
            </span>
            {cat.name}
          </Link>
        );
      })}
    </div>
  );
}